/* eslint-disable vue/attribute-hyphenation */
<!-- FUNDUS Photo component -->
<template>
  <md-card id="fundus" class="md-with-hover" @mouseover.native="mouseOver" @mouseleave.native="mouseLeave">
    <md-card-header class="md-card-header-icon md-card-header-primary">
      <div class="md-layout">
        <div class="card-icon" style="margin-left: 5px; margin-top: -7px; margin-right: 0px">
          <md-icon>remove_red_eye</md-icon>
        </div>
        <div class="md-layout-item">
          <h4 class="title" style="font-weight: 400">FUNDUS PHOTO</h4>
        </div>
        <div class="md-layout md-layout-item md-alignment-center-right">
          <md-button
            v-show="addnlFUN"
            slot="title"
            class="md-button md-warning md-sm"
            style="margin-top: 15px; margin-right: 10%"
            @click.prevent="toggleImgBox"
          >
            ADD'L IMAGES
          </md-button>
        </div>
      </div>
    </md-card-header>

    <md-card-content>
      <!-- ROW HEADINGS -->
      <div class="md-layout md-gutter md-alignment-space-around-center" style="text-align: center">
        <div class="md-layout-item">
          <label for="diagFunOD" style="font-weight: bold">RIGHT</label>
        </div>

        <div class="md-layout-item">
          <label for="diagFunOS" style="font-weight: bold">LEFT</label>
        </div>
      </div>
      <hr style="width: 98%" />

      <!-- ROW images -->
      <div class="md-layout md-gutter md-alignment-space-around-center" style="text-align: Left">
        <div class="md-layout-item" style="padding: 2px 5px 2px 20px">
          <drop class="drop" @drop="handleDropOD">
            <img
              v-if="noFunOD"
              :style="imgStyle"
              name="paceholder"
              src="@/assets/img/imageNA.jpg"
              height="120px"
              width="auto"
            />

            <img
              v-else
              :src="imgFunOD_Url"
              :style="imgStyle"
              name="imgFunOD"
              alt="Fundus OD"
              height="120px"
              width="auto"
              @click="funModal(imgFunOD_Url)"
            />
          </drop>
        </div>

        <div class="md-layout-item" style="padding: 2px">
          <drop class="drop" @drop="handleDropOS">
            <img
              v-if="noFunOS"
              :style="imgStyle"
              name="paceholder"
              src="@/assets/img/imageNA.jpg"
              alt="Fundus OS"
              height="120px"
              width="auto"
            />

            <img
              v-else
              :src="imgFunOS_Url"
              :style="imgStyle"
              name="imgFunOS"
              alt="Fundus OS"
              height="120px"
              width="auto"
              @click="funModal(imgFunOS_Url)"
            />
          </drop>
        </div>
      </div>
      <hr style="width: 98%" />

      <!-- ROW LISTBOXES -->
      <div class="md-layout md-gutter md-alignment-space-around-center" style="margin-left: -15px">
        <findings-search :section="Section" :sectionName="SectionName" :mState="mState" />

        <hr style="margin: 0; padding: 0" />
      </div>
    </md-card-content>

    <hr />

    <!-- MODAL LARGE IMAGE -->
    <modal v-if="winModal" md-dynamic-height>
      <template slot="header">
        <div class="md-layout md-alignment-center-right">
          <div class="md-layout-item"></div>
          <div class="md-layout-item md-alignment-top-right" align="right">
            <md-icon class="exit-icon" style="color: red" @click.native="winModal = false">cancel</md-icon>
          </div>
        </div>
      </template>
      <template slot="body">
        <div v-if="FunModal" class="md-layout" @click="winModal = false">
          <div class="md-layout-item">
            <img :src="ModalImg" height="300px;" width="auto" />
          </div>
        </div>
      </template>
    </modal>
  </md-card>
</template>

<script>
import { mapGetters } from "vuex"
import { Modal } from "@/components"
import { bus } from "@/main"
import FindingsSearch from "@/components/GlobeChek/screening/findings/Top5Findings"
export default {
  name: "PhotoFundus",
  components: {
    "findings-search": FindingsSearch,
    Modal
  },
  props: {},
  data() {
    return {
      Section: "Fundus",
      SectionName: "Fundus Photo",
      chk_Fun: false,
      mState: false,
      ModalImg: "",
      replaceImgOD: null,
      replaceImgOS: null,
      normal: null,
      normalStyle: "",
      winModal: false,
      FunModal: false,
      imgStyle: "",
      imgStyleInactive: "filter:grayscale(100%);",
      imgStyleActive: ""
    }
  },
  computed: {
    ...mapGetters(["fundusPhoto", "imagesPath", "addnlFUN", "getImageUrlByIds"]),

    noFunOD() {
      if (this.replaceImgOD) {
        return false
      } else {
        if (this.getImageUrlByIds("fundus", ["FUNMACOD", "FUN_3"]) == false) {
          return true
        }
      }
    },
    noFunOS() {
      if (this.replaceImgOS) {
        return false
      } else {
        if (this.getImageUrlByIds("fundus", ["FUNMACOD", "FUN_3"]) == false) {
          return true
        }
      }
    },
    imgFunOD_Url() {
      if (this.replaceImgOD) {
        return this.replaceImgOD
      } else {
        return this.getImageUrlByIds("fundus", ["FUNMACOD", "FUN_3"])
      }
    },
    imgFunOS_Url() {
      if (this.replaceImgOS) {
        return this.replaceImgOS
      } else {
        return this.getImageUrlByIds("fundus", ["FUNMACOS", "FUN_4"])
      }
    }
  },
  mounted: function () {
    this.imgStyle = this.imgStyleInactive
  },
  methods: {
    toggleImgBox() {
      bus.$emit("toggleImgBox", "FUN")
    },
    mouseOver: function () {
      try {
        this.mState = true
        this.imgStyle = this.imgStyleActive
        this.normalStyle = false
      } catch (error) {
        console.log(error)
      }
    },
    mouseLeave: function () {
      try {
        this.mState = false
        this.imgStyle = this.imgStyleInactive
        this.normalStyle = "disabled"
      } catch (error) {
        console.log(error)
      }
    },
    clearModal() {
      this.winModal = false
      this.FunModal = false
      this.FindingModal = false
    },
    funModal: function (img) {
      this.clearModal()
      this.ModalImg = img
      this.winModal = true
      this.FunModal = true
    },
    handleDropOD(data) {
      //console.log(`You droppped: ${JSON.stringify(data)}`);
      this.replaceImgOD = data.url
      this.$store.dispatch("SetImgReplace", { FUNOD: data.url })
      this.$forceUpdate()
    },
    handleDropOS(data) {
      //console.log(`You droppped: ${JSON.stringify(data)}`);
      this.replaceImgOS = data.url
      this.$store.dispatch("SetImgReplace", { FUNOS: data.url })
      this.$forceUpdate()
    },
  }
}
</script>

<style lang="scss" scoped>
#fundus {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}

.values {
  font-size: 0.7rem;
  padding: 0px;
  margin-top: 10px;
  line-height: 1.4em;
  font-weight: 200;
}

.values2 {
  padding: 0px;
  font-weight: 350;
  font-size: 12pt;
  line-height: 14px;
  align-content: start;
}

.mswitch {
  color: rgba(46, 46, 46, 0.8) !important;
  font-size: 0.8rem;
}

.mswitch-normal {
  color: rgba(0, 98, 211, 0.8) !important;
  font-size: 0.95rem;
}

.drag,
.drop {
  font-family: sans-serif;
  display: inline-block;
  border-radius: 0px;
  background: #ccc;
  position: relative;
  padding: 0px;
  text-align: center;
  vertical-align: top;
}

.drag {
  color: #fff;
  cursor: move;
  background: #777;
  border-right: 2px solid #555;
  border-bottom: 2px solid #555;
}

.drop {
  background: #eee;
  border-top: 2px solid #ccc;
  border-left: 2px solid #ccc;
}
</style>
